import React, { useState, useEffect } from "react";
import "./SlidingHeader.scss";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const messages = [
  "Welcome to our shop's official site",
  "Limited-time offers available!",
  "Check out our new products!",
  "Follow us on facebook!",
];

function SlidingHeader() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000); // Auto-slide every 5 seconds
    return () => clearInterval(interval);
  }, [index]);

  const nextSlide = () => {
    setIndex((prevIndex) => (prevIndex + 1) % messages.length);
  };

  const prevSlide = () => {
    setIndex(
      (prevIndex) => (prevIndex - 1 + messages.length) % messages.length
    );
  };

  return (
    <header className="sliding-header">
      <button className="arrow left" onClick={prevSlide}>
        <FaChevronLeft />
      </button>
      <div className="message">{messages[index]}</div>
      <button className="arrow right" onClick={nextSlide}>
        <FaChevronRight />
      </button>
    </header>
  );
}

export default SlidingHeader;
